import {
    alimentacao,
    farmacias,
    abastecimento,
    refeicao,
    outros,
    pinfarmacia,
    pinoutros,
    pinrefeicao,
    pinabastecimento,
    pinalimentacao,
    favpinfarmacia,
    favpinoutros,
    favpinrefeicao,
    favpinabastecimento,
    favpinalimentacao, 
    focuspinfarmacias, 
    focuspinoutros, 
    focuspinabastecimento, 
    focuspinrefeicao, 
    focuspinalimentacao,
    favfocuspinoutros,
    favfocuspinfarmacia,
    favfocuspinrefeicao,
    favfocuspinabastecimento,
    favfocuspinalimentacao
} from "assets/images";

function toRadians(value) {
    return (value * Math.PI) / 180;
}

function calculateDistance(estabelecimento, userLocation) {
    let R = 6371e3; // metros
    let la1 = toRadians(userLocation.lat);
    let la2 = toRadians(estabelecimento.lat);
    let latitudeDifference = toRadians(estabelecimento.lat - userLocation.lat);
    let longitudeDifference = toRadians(estabelecimento.lng - userLocation.lng);

    let a =
        Math.sin(latitudeDifference / 2) * Math.sin(latitudeDifference / 2) +
        Math.cos(la1) *
            Math.cos(la2) *
            Math.sin(longitudeDifference / 2) *
            Math.sin(longitudeDifference / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

function drawCircle(point, radius, dir) {
    let d2r = Math.PI / 180; // degrees to radians
    let r2d = 180 / Math.PI; // radians to degrees
    let earthsradius = 3963; // 3963 is the radius of the earth in miles use 6371 if using kilometers
    let points = 32;
    let start, end;

    // find the raidus in lat/lon
    let rlat = (radius / earthsradius) * r2d;
    let rlng = rlat / Math.cos(point.lat * d2r);

    let extp = [];
    if (dir === 1) {
        start = 0;
        end = points + 1;
    } // one extra here makes sure we connect the ends
    else {
        start = points + 1;
        end = 0;
    }
    for (let i = start; dir === 1 ? i < end : i > end; i = i + dir) {
        let theta = Math.PI * (i / (points / 2));
        let ey = point.lng + rlng * Math.cos(theta); // center a + radius x * cos(theta)
        let ex = point.lat + rlat * Math.sin(theta); // center b + radius y * sin(theta)
        extp.push({ lat: ex, lng: ey });
        //   bounds.extend(extp[extp.length-1]);
    }

    return extp;
}

function pin(categoria, isMarker = false, isFavorite = false) {
    switch (categoria) {
        case "FARMÁCIAS":
            if (isMarker) {
                if (isFavorite) {
                    return favpinfarmacia;
                } else {
                    return pinfarmacia;
                }
            } else {
                return farmacias;
            }

        case "OUTROS":
            if (isMarker) {
                if (isFavorite) {
                    return favpinoutros;
                } else {
                    return pinoutros
                }
            } else {
                return outros;
            }

        case "RESTAURANTES":
            if (isMarker) {
                if (isFavorite) {
                    return favpinrefeicao;
                } else {
                    return pinrefeicao
                }
            } else {
                return refeicao;
            }

        case "POSTOS DE COMBUSTÍVEIS":
            if (isMarker) {
                if (isFavorite) {
                    return favpinabastecimento;
                } else {
                    return pinabastecimento
                }
            } else {
                return abastecimento;
            }

        case "SUPERMERCADOS":
            if (isMarker) {
                if (isFavorite) {
                    return favpinalimentacao;
                } else {
                    return pinalimentacao
                }
            } else {
                return alimentacao;
            }

        default:
            if (isMarker) {
                if (isFavorite) {
                    return favpinoutros;
                } else {
                    return pinoutros
                }
            } else {
                return outros;
            }
    }
}

function focusPin(categoria, isMarker = false, isFavorite = false) {
    switch (categoria) {
        case "FARMÁCIAS":
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinfarmacia;
                } else {
                    return focuspinfarmacias;
                }
            } else {
                return farmacias;
            }

        case "OUTROS":
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinoutros;
                } else {
                    return focuspinoutros
                }
            } else {
                return outros;
            }

        case "RESTAURANTES":
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinrefeicao;
                } else {
                    return focuspinrefeicao
                }
            } else {
                return refeicao;
            }

        case "POSTOS DE COMBUSTÍVEIS":
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinabastecimento;
                } else {
                    return focuspinabastecimento
                }
            } else {
                return abastecimento;
            }

        case "SUPERMERCADOS":
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinalimentacao;
                } else {
                    return focuspinalimentacao
                }
            } else {
                return alimentacao;
            }

        default:
            if (isMarker) {
                if (isFavorite) {
                    return favfocuspinoutros;
                } else {
                    return focuspinoutros
                }
            } else {
                return outros;
            }
    }
}

export { calculateDistance, drawCircle, pin, focusPin};